var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 18.3848L18.3848 -1.03712e-05L20.5061 3.53552L2.82843 21.2132L0 18.3848Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M2.82812 0L21.2129 18.3848L18.3845 21.2132L-0.000302076 2.82843L2.82812 0Z","fill":"currentColor","key":1})]);
}

Close.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = Close;

Close.default = Close;
